import React from 'react';
import {ReactComponent as TriangleErrorIco} from "../../../../../images/icons/triangle-error.svg";
import RoundedIcon from "../../../Common/RoundedIcon";
import {useTranslation} from "react-i18next";

const CartButtonTemporarilyClosedInfo = ({}) => {
    const {t} = useTranslation();

    return (
        <div className="cart-button-info">
            <RoundedIcon icon={<TriangleErrorIco/>} size="medium" color="warning"/>
            <div className="cart-button-info-middle-box">
                <span className="font-weight-bold text-warning">
                    {t("modules.temporarily_closed_modal.header.title")}
                </span>
                <span className="text-muted">
                    {t("modules.temporarily_closed_modal.field.cannot_place_orders.title")}
                </span>
            </div>
        </div>
    )
}

export default CartButtonTemporarilyClosedInfo;